import { render, staticRenderFns } from "./CredentialsDetailsWithAsyncFallback.vue?vue&type=template&id=49594fd5&scoped=true&"
import script from "./CredentialsDetailsWithAsyncFallback.vue?vue&type=script&lang=js&"
export * from "./CredentialsDetailsWithAsyncFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49594fd5",
  null
  
)

export default component.exports